import React from 'react';
import { Handle, Position, NodeProps } from 'reactflow';

// Define expected data structure for this node
interface EnrichmentNodeData {
  label?: string;
  enrichmentCount?: number; // Example: show how many enrichments are configured
}

const EnrichmentNode: React.FC<NodeProps<EnrichmentNodeData>> = ({ data }) => {
  const label = data?.label || 'Enrichments';
  const count = data?.enrichmentCount ?? 0;

  return (
    <div className="playbook-node enrichment-node" style={{ width: 180 }}>
      <Handle type="target" position={Position.Left} id="input" style={{ background: '#555' }} />
      <div className="playbook-node-header" style={{ justifyContent: 'center' }}>
        <strong>{label}</strong>
      </div>
      <div style={{ padding: '5px 0', fontSize: '0.9em', color: '#555', textAlign: 'center' }}>
        ({count} configured)
      </div>
      <Handle type="source" position={Position.Right} id="output" style={{ background: '#555' }} />
    </div>
  );
};

export default EnrichmentNode;
